import { WbsItemBasic } from '../../../../lib/functions/wbsItem'
import { wbsItemBasicCache } from '../wbsItemBasicCache'
import { BasicLookup, useBasicByCode } from './useBasicByCode'

export type WbsItemBasicLookup = BasicLookup<WbsItemBasic>

export const useWbsItemBasicByCode = (code: string): WbsItemBasicLookup =>
  useBasicByCode(wbsItemBasicCache, code)
